import { defaultTransParamValue } from "../../data/metadata/transactionMetadata";

const initState = {
  transactionParams: {
    economicCode: defaultTransParamValue.economicCode,
    endTimestamp: defaultTransParamValue.endTimestamp,
    startTimestamp: defaultTransParamValue.startTimestamp,
  },
};

const transactionParamsReducer = (state = initState, action) => {
  switch (action.type) {
    case "TRANS_PARAMS":
      return {
        ...state,
        transactionParams: action.payload,
      };

    default:
      return state;
  }
};

export default transactionParamsReducer;
